import React, { Component } from "react";

// Components
import ErrorWrap from "../../../utils/error-success/ErrorWrap";

// CKeditor
import CKEditor from "react-ckeditor-component";
import { editorReady } from "../../../../utils/editor";
import CKEditorInput from "../../../../utils/forms/CKEditorInput";

class NotesFieldset extends Component {
	constructor(props) {
		super(props);
		this.CKEditorInput = new CKEditorInput();

		this.dataProps = ["cc_notes", "notes"];
		this.miscProps = ["errors"];
	}

	shouldComponentUpdate(nextProps) {
		// If the parent component is processing, we should re-render to show disabled states, etc
		if (this.props.inProcess !== nextProps.inProcess) {
			this.CKEditorInput.setCKReadonly(nextProps.inProcess);
			return true;
		}

		// Check local props to see if any have changed
		const dataPropResults = this.dataProps.some(prop => {
			return this.props.data[prop] !== nextProps.data[prop];
		});
		const miscPropResults = this.miscProps.some(prop => {
			return this.props[prop] !== nextProps[prop];
		});

		// If any local props changed, we will rerender
		return dataPropResults || miscPropResults;
	}

	render() {
		const { data, errors } = this.props;

		return (
			<div className="fieldset">
				<div className="title-label">Notes</div>

				<div className="fieldset-indent">
					<div className="form-field">
						<label>CC Notes:</label>

						{!!errors.cc_notes && <ErrorWrap animate={1}>{errors.cc_notes}</ErrorWrap>}
						<CKEditor
							scriptUrl="/ckeditor/ckeditor.js"
							content={data.cc_notes}
							config={{
								toolbar: "BasicWithTools",
								filebrowserBrowseUrl: "/file-browser",
								uploadUrl: process.env.REACT_APP_API_URL + `files`
							}}
							events={{
								instanceReady: editorReady.bind(this),
								change: this.props.editorChange.bind(this, "cc_notes")
							}}
							ref={instance => {
								this.CKEditorInput.addEditor("cc_notes", instance);
							}}
						/>
					</div>

					<div className="form-field">
						<label>Notes:</label>

						{!!errors.notes && <ErrorWrap animate={1}>{errors.notes}</ErrorWrap>}
						<CKEditor
							scriptUrl="/ckeditor/ckeditor.js"
							content={data.notes}
							config={{
								toolbar: "BasicWithTools",
								filebrowserBrowseUrl: "/file-browser",
								uploadUrl: process.env.REACT_APP_API_URL + `files`
							}}
							events={{
								instanceReady: editorReady.bind(this),
								change: this.props.editorChange.bind(this, "notes")
							}}
							ref={instance => {
								this.CKEditorInput.addEditor("notes", instance);
							}}
						/>
					</div>
				</div>
			</div>
		);
	}
}

export default NotesFieldset;



// WEBPACK FOOTER //
// ./src/components/admin/organizations/form-components/NotesFieldset.js